import React, { Fragment } from "react";
import {
  Badge,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Menu,
  Typography
} from "@material-ui/core";


import image from "./user.png";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useStyles } from "../../assets/js/HeaderStyle";

function ObtenerNombreUsuario() {
  //console.log(window.sessionStorage.getItem("usuario"));
  const dataLogin = JSON.parse(window.sessionStorage.getItem("usuario"));
  return dataLogin.result;
  
  //console.log(JSON.parse(undefined));
}

export default function Profile() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    //console.log("handleClicked ", event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dropDownData = [
    { label: "Configuración", icon: <SettingsIcon /> },
    { label: "Salir", icon: <ExitToAppIcon /> },
  ];


  const data1 = ObtenerNombreUsuario();
  // console.log(data1);

  return (
    <Fragment>
       <ListItemText
          className={classes.nombrepila}
          primary={
            <React.Fragment>
              <Typography
                sx={{ display: 'block' }}
                variant="body2"
              >
              {data1.colaborador.nombre}{" "}
              {data1.colaborador.apellidoPaterno}
              </Typography>
              
            </React.Fragment>
          }
          secondary={data1.perfil}
        />
      <IconButton
        aria-controls='profile'
        aria-haspopup='true'
        // onClick={handleClick}
        color='inherit'>
        <Badge overlap="rectangular" badgeContent={null} color='secondary'>
          <img alt={image} src={image} className={classes.navImg} />
        </Badge>
      </IconButton>
      {/* <Menu
        id='profile'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        placement='bottom-start'>
        <List dense={true} className={classes.dropdownlist}>
          {dropDownData.map((item, i) => (
            <ListItem
              key={i}
              component={Button}
              onClick={handleClose}
              className={classes.listItem}>
              <ListItemAvatar>{item.icon}</ListItemAvatar>
              <ListItemText primary={item.label}></ListItemText>
            </ListItem>
          ))}
        </List>
      </Menu> */}
    </Fragment>
  );
}
